package components.menus.sidebar

import components.routing.ApplicationRoutingUrls
import mui.icons.material.Inventory
import mui.icons.material.Logout
import mui.icons.material.Receipt
import mui.icons.material.ReceiptLong

val MenuItemMapping = arrayOf<MenuItem>(
    MenuItem(
        title = "Stock",
        href = ApplicationRoutingUrls.Protected.stockListPage,
        icon = Inventory
    ),
    MenuItem(
        title = "Inbound",
        href = ApplicationRoutingUrls.Protected.inboundListPage,
        icon = ReceiptLong
    ),
    MenuItem(
        title = "Outbound",
        href = ApplicationRoutingUrls.Protected.outboundListPage,
        icon = Receipt
    ),
    MenuItem(
        title = "Deliveries",
        href = ApplicationRoutingUrls.Protected.deliveriesListPage,
        icon = Receipt
    ),
    MenuItem(
        title = "Logout",
        icon = Logout,
        logout = true
    )
)